import { AsyncPaginate } from "react-select-async-paginate";
import { getData } from "../../webService/webservice.js";

export const ALL_STORE_OPTION = {
    label: "All Stores",
    value: "",
};

export const STORE_OPTION = {
    label: "All Stores",
    value: "",
};

const defaultStyles = {
    container: (base) => ({
        ...base,
        minWidth: 180,
        width: "280px",
        fontSize: "13px",
    }),
    control: (base, state) => ({
        ...base,
        minHeight: "38px",
        height: "38px",
        background: state.isFocused ? "#ffffff" : "#f8fafc",
        borderColor: state.isFocused ? "#1e293b" : "#e2e8f0",
        borderRadius: "10px",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(30, 41, 59, 0.05)" : "none",
        fontSize: "14px",
        fontWeight: "500",
        color: "#1e293b",
        transition: "all 0.2s ease",
        cursor: "pointer",
        "&:hover": {
            borderColor: "#1e293b",
        },
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0 10px",
        height: "38px",
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        overflow: "hidden",
    }),
    singleValue: (base) => ({
        ...base,
        color: "#1e293b",
        fontWeight: "500",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
    }),
    placeholder: (base) => ({
        ...base,
        color: "#94a3b8",
        fontWeight: "400",
    }),
    input: (base) => ({
        ...base,
        margin: "0",
        padding: "0",
        color: "#1e293b",
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: "38px",
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: "0 10px",
        color: "#94a3b8",
        "&:hover": {
            color: "#1e293b",
        },
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    menu: (base) => ({
        ...base,
        borderRadius: "10px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 10px 25px -5px rgba(0,0,0,0.1)",
        overflow: "hidden",
        zIndex: 9999,
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999,
    }),
    option: (base, state) => ({
        ...base,
        fontSize: "14px",
        fontWeight: state.isSelected ? "600" : "400",
        color: state.isSelected ? "#1e293b" : "#475569",
        background: state.isSelected
            ? "#f1f5f9"
            : state.isFocused
                ? "#f8fafc"
                : "#ffffff",
        cursor: "pointer",
        padding: "10px 14px",
        "&:active": {
            background: "#e2e8f0",
        },
    }),
};

const mergeStyles = (defaults, custom) => {
    if (!custom) return defaults;
    const merged = { ...defaults };
    Object.keys(custom).forEach((key) => {
        const defaultFn = defaults[key];
        const customFn = custom[key];
        if (typeof customFn === "function") {
            merged[key] = (base, state) => {
                const defaultResult = defaultFn ? defaultFn(base, state) : base;
                return customFn(defaultResult, state);
            };
        } else {
            merged[key] = customFn;
        }
    });
    return merged;
};

const StoreSingleAllStoresSelect = ({ value, onChange, showAll = true, customStyles }) => {
    const loadStores = async (search, loadedOptions, { page }) => {
        try {
            const token = localStorage.getItem("Token");

            const data = await getData(
                "stores/stores",
                {
                    page,
                    limit: 20,
                    search,
                },
                token
            );

            const results = data?.data?.results || [];
            const currentPage = data?.data?.currentPage || page;
            const totalPages = data?.data?.totalPages || 1;

            const apiOptions = results.map((s) => ({
                label: s.storeName,
                value: s._id,
                raw: s,
            }));

            STORE_OPTION.label = apiOptions?.[0]?.label;
            STORE_OPTION.value = apiOptions?.[0]?.value;

            return {
                options:
                    showAll && page === 1
                        ? [ALL_STORE_OPTION, ...apiOptions]
                        : apiOptions,
                hasMore: currentPage < totalPages,
                additional: {
                    page: currentPage + 1,
                },
            };
        } catch (e) {
            console.error("Failed to load stores", e);
            return {
                options: showAll && page === 1 ? [ALL_STORE_OPTION] : [],
                hasMore: false,
                additional: { page },
            };
        }
    };

    const styles = mergeStyles(defaultStyles, customStyles);

    return (
        <AsyncPaginate
            value={value}
            loadOptions={loadStores}
            additional={{ page: 1 }}
            onChange={(opt) => {
                onChange(opt);
            }}
            placeholder="Select Store"
            styles={styles}
            menuPortalTarget={document.body}
            menuPlacement="auto"
        />
    );
};

export default StoreSingleAllStoresSelect;
